import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import IndustrialDetails from './section-components/industrial-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const IndustrialSchool = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best Industrial School Course in Chennai | Industrial School Training</title>
            <meta name="description" content="Get the best Industrial School Courses in Chennai at MIET which offers the top Industrial Training Courses, to make you a professional from the industry" />
        </Helmet>
        <PageHeader headertitle="Industrial School"  />
        <IndustrialDetails />
        <Footer />
    </div>
}

export default IndustrialSchool

